import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import ShippingIcon from './ShippingIcon';
import Title from './Title';

import ShippingSelector from 'js/components/core/form/ShippingSelector';

export default inject('page')(
  observer(({ page }) => (
    <Container>
      <ShippingIcon />
      <Title>Shipping method</Title>
      <ShippingSelector
        state={page.shippingSelector}
        alias={page.alias}
        destination={page.address}
        onChange={page.setShippingService}
        noAnimation
      />
      <SubmitRow>
        <Button onClick={page.closeModal} disabled={!page.shipping_service}>
          Save
        </Button>
      </SubmitRow>
    </Container>
  )),
);
